/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import SegmentConstants from 'constants/SegmentConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'
import { isSegmentHidden } from 'utils/SegmentSelectHelper'

const SegmentQueries = Marty.createQueries({
  id: 'SegmentQueries',

  tryPushNotificationOnSegmentCreation(segment) {
    if (!isSegmentHidden(segment)) {
      return this.app.actions.NotificationActions.pushNotification({
        content: `You've created a new segment: ${ segment.name }`,
        viewLinkTo: {
          pathname: `/contacts/segments/${segment.id}`,
          target: '_self'
        }
      })
    }
  },

  createSegment(requestId, body, endUserIds) {
    this.dispatch(SegmentConstants.SEGMENT_CREATE_STARTING, requestId, body, endUserIds)

    const promise = this.app.sources.SegmentAPI.createSegment(body)

    promise.then(res => {
      if (res.status === 200) {
        if (endUserIds) {
          const addEndUserIdsPromise = this.app.queries.SegmentQueries.addEndUserIdsToStaticSegment(res.body.id, endUserIds, false)

          addEndUserIdsPromise.then(() => {
            this.dispatch(SegmentConstants.SEGMENT_CREATE_DONE, requestId, res.body)
            const segment = res.body
            return this.tryPushNotificationOnSegmentCreation(segment)
          })

          return addEndUserIdsPromise.catch(error => {
            captureException(error)
            return this.dispatch(SegmentConstants.SEGMENT_CREATE_FAILED, requestId, body, endUserIds, error)
          })
        } else {
          this.dispatch(SegmentConstants.SEGMENT_CREATE_DONE, requestId, res.body)
          return this.tryPushNotificationOnSegmentCreation(res.body)
        }
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENT_CREATE_FAILED, requestId, body, endUserIds, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENT_CREATE_FAILED, body, endUserIds, error)
    })
  },

  addEndUserIdsToStaticSegment(segmentId, endUserIds, notify) {
    if (notify == null) { notify = true }
    this.dispatch(SegmentConstants.SEGMENT_ADD_MEMBERS, segmentId, endUserIds)

    const promise = this.app.sources.SegmentAPI.addEndUserIdsToStaticSegment(segmentId, endUserIds)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(SegmentConstants.SEGMENT_ADD_MEMBERS_DONE, segmentId)
        if (notify) {
          return this.app.actions.NotificationActions.pushNotification({
            content: `Successfully added ${ endUserIds.length } users to segment`,
            viewLinkTo: {
              pathname: `/contacts/segments/${segmentId}`,
              target: '_self'
            }
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENT_ADD_MEMBERS_FAILED, segmentId, endUserIds, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENT_ADD_MEMBERS_FAILED, segmentId, endUserIds, error)
    })
  },

  deleteEndUserIdsFromStaticSegment(segmentId, endUserIds, notify) {
    if (notify == null) { notify = true }
    this.dispatch(SegmentConstants.SEGMENT_DELETE_MEMBERS_STARTING, segmentId, endUserIds)

    const promise = this.app.sources.SegmentAPI.deleteEndUserIdsFromStaticSegment(segmentId, endUserIds)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(SegmentConstants.SEGMENT_DELETE_MEMBERS_DONE, segmentId)
        if (notify) {
          return this.app.actions.NotificationActions.pushNotification({
            content: `Successfully removed ${ endUserIds.length } users from segment`,
            viewLinkTo: {
              pathname: `/contacts/segments/${segmentId}`,
              target: '_self'
            }
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENT_DELETE_MEMBERS_FAILED, segmentId, endUserIds, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENT_DELETE_MEMBERS_FAILED, segmentId, endUserIds, error)
    })
  },

  elasticSearchMembersOfSegment(segmentId, from, size) {
    const promise = this.app.sources.SegmentAPI.elasticSearchMembersOfSegment(segmentId, from, size)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(SegmentConstants.SEGMENT_ELASTIC_SEARCH_MEMBERS_DONE, segmentId, from, size, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENT_ELASTIC_SEARCH_MEMBERS_FAILED, segmentId, from, size, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENT_ELASTIC_SEARCH_MEMBERS_FAILED, segmentId, from, size, error)
    })
  },

  fetchSegments() {
    const promise = this.app.sources.SegmentAPI.fetchSegments()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(SegmentConstants.SEGMENTS_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENTS_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENTS_FETCH_FAILED, error)
    })
  },

  fetchSegment(segmentId) {
    const promise = this.app.sources.SegmentAPI.fetchSegment(segmentId)
    promise.then(res => {
      // res.members = result[1]

      if (res.status === 200) {
        return this.dispatch(SegmentConstants.SEGMENT_FETCH_DONE, segmentId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.SEGMENT_FETCH_FAILED, segmentId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.SEGMENT_FETCH_FAILED, segmentId, error)
    })
  },

  deleteSegment(segmentId) {
    const promise = this.app.sources.SegmentAPI.updateSegment(segmentId, { status: 'ARCHIVED' })
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(SegmentConstants.DELETE_SEGMENT_DONE, segmentId, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: 'Segment Deleted!',
          variant: 'red'
        })
      } else {
        captureResponseException(res)
        return this.dispatch(SegmentConstants.DELETE_SEGMENT_FAILED, segmentId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(SegmentConstants.DELETE_SEGMENT_FAILED, segmentId, error)
    })
  },

  getCampaignsForSegment(segmentId) {
    const promise = this.app.sources.CampaignAPI.getCampaignsForSegment(segmentId)
    return promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(SegmentConstants.GET_CAMPAIGNS_FOR_SEGMENT_DONE, segmentId, res.body)
      }
    })
  }
})

export default SegmentQueries


// WEBPACK FOOTER //
// ./src/scripts/queries/SegmentQueries.js